import { Component, Input } from '@angular/core';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';

@Component({
  selector: 'app-participant-location',
  imports: [AddressLabelComponent, DetailPanelComponent, DetailItemComponent],
  template: `<div class="tw-flex tw-gap-8">
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="Building" name="building" />
        <app-detail-item label="Location" name="location" />
        <app-detail-item label="Address">
          <ng-template let-data #value>
            <app-address-label
              [street1]="dataSource.address1"
              [street2]="dataSource.address2"
              [city]="dataSource.city"
              [state]="dataSource.state"
              [postalCode]="dataSource.postalCode"
              [county]="dataSource.county"
              [country]="dataSource.country"
            />
          </ng-template>
        </app-detail-item>
      </app-detail-panel>
    </div>
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="License Number" name="licenseNumber" />
        <app-detail-item label="License State" name="licenseState" />
      </app-detail-panel>
    </div>
  </div>`,
  styles: [],
})
export class ParticipantLocationComponent {
  @Input() dataSource: any;
}
